module.exports = __webpack_public_path__ + "static/img/img1.da9f948.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/5/img1.png
// module id = oCsM
// module chunks = 0